
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M14.583 4.5h-3.125c-.386 0-.757.193-1.03.537-.274.344-.428.81-.428 1.296 0 .487.154.953.427 1.297.274.344.645.537 1.031.537m0 0h2.084c.386 0 .757.193 1.03.537.274.343.428.81.428 1.296s-.154.953-.427 1.296c-.274.344-.645.537-1.031.537m-2.084-3.666c-.386 0-.757.193-1.03.537-.274.343-.428.81-.428 1.296s.154.953.427 1.296c.274.344.645.537 1.031.537h2.084m0 0c.386 0 .757.194 1.03.537.274.344.428.81.428 1.297s-.154.952-.427 1.296c-.274.344-.645.537-1.031.537H10m-3.417-13H3.458c-.386 0-.757.193-1.03.537-.274.344-.428.81-.428 1.296 0 .487.154.953.427 1.297.274.344.645.537 1.031.537m0 0h2.084c.386 0 .757.193 1.03.537C6.847 7.047 7 7.514 7 8s-.154.953-.427 1.296c-.274.344-.645.537-1.031.537M3.458 6.167c-.386 0-.757.193-1.03.537C2.153 7.047 2 7.514 2 8s.154.953.427 1.296c.274.344.645.537 1.031.537h2.084m0 0c.386 0 .757.194 1.03.537.274.344.428.81.428 1.297s-.154.952-.427 1.296c-.274.344-.645.537-1.031.537H2"}})])
          )
        }
      }
    